import { render, staticRenderFns } from "./cart-calculation-setting-form.vue?vue&type=template&id=2c3f85fa"
import script from "./cart-calculation-setting-form.vue?vue&type=script&lang=js"
export * from "./cart-calculation-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports